import { ScLabsAreaRoutes } from '@backoffice-frontend/common'
import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
// Area Navigation component
// This file was once generated when you created this area
// but you can edit it freely
import { LightbulbIcon } from '@moia-dev/pace-icons'

// TODO: add your NavigationItem to the main menu
// check docs/how-tos/add-a-new-library.md for more info

// TODO: Replace icon with your actual area icon
export const ScLabsAreaNavigationIcon = LightbulbIcon

export const ScLabsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={ScLabsAreaRoutes.route}
      Icon={LightbulbIcon}
    />
  )
}
